import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleOrderURL = `api/v1/sales-app/sales-order`;

//obtaining the paginated data
export const getSaleOrder = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderURL}/list?ref_voucher=sales_quotation&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleOrder = () => axiosInstance.get(`${saleOrderURL}/list?ref_voucher=sales_quotation&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleOrder = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleOrderURL}/list?ref_voucher=sales_quotation&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getSaleOrderAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?ref_voucher=sales_quotation&is_active=true`);

// get by id
export const getSaleOrderById = (id) => axiosInstance.get(`${saleOrderURL}/retrieve/${id}`);

//creating function
export const createSaleOrder = (body) => axiosInstance.post(`${saleOrderURL}/create`, body);
//updating function
export const updateSaleOrder = (id, body) => axiosInstance.patch(`${saleOrderURL}/update/${id}`, body);

//converting to Sale Invoice From Sales Order
export const convertToSaleInvoice = (body) => axiosInstance.post(`api/v1/sales-app/sales-invoice/branch/create`, body);

// api/v1/sales-app/sales-order

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderURL}/list?ref_voucher=sales_quotation&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
